module.exports = __webpack_public_path__ + "media/src/images/icons/gift-b43b09f50dd15dc7335de35455e26e60.svg";